/**
 * Centralized Size Data - Single Source of Truth
 * 
 * All size measurements for BJJ Gi and No-Gi products.
 * Update this file to change sizing across the entire theme.
 * 
 * Height values are in inches (for calculations)
 * Weight values are in pounds (for calculations)
 */

window.BasicsSizeData = (function() {
  'use strict';

  // ============================================
  // BJJ GI SIZES (A0, A1, A1L, A2, A2L, A2H, A3, A4)
  // ============================================
  const giSizes = {
    'A0': {
      height: { min: 60, max: 65, display: "5'0\" - 5'5\"" },
      weight: { min: 110, max: 140, display: "110-140 lbs" },
      chest: { min: 34, max: 38, display: "34-38\"" },
      build: 'Standard'
    },
    'A1': {
      height: { min: 65, max: 69, display: "5'5\" - 5'9\"" },
      weight: { min: 140, max: 170, display: "140-170 lbs" },
      chest: { min: 38, max: 42, display: "38-42\"" },
      build: 'Standard'
    },
    'A1L': {
      height: { min: 68, max: 72, display: "5'8\" - 6'0\"" },
      weight: { min: 145, max: 185, display: "145-185 lbs" },
      chest: { min: 38, max: 44, display: "38-44\"" },
      build: 'Tall & Lean'
    },
    'A2': {
      height: { min: 69, max: 73, display: "5'9\" - 6'1\"" },
      weight: { min: 180, max: 215, display: "180-215 lbs" },
      chest: { min: 42, max: 46, display: "42-46\"" },
      build: 'Standard'
    },
    'A2L': {
      height: { min: 74, max: 76, display: "6'2\" - 6'4\"" },
      weight: { min: 175, max: 215, display: "175-215 lbs" },
      chest: { min: 42, max: 48, display: "42-48\"" },
      build: 'Tall & Lean'
    },
    'A2H': {
      height: { min: 67, max: 70, display: "5'7\" - 5'10\"" },
      weight: { min: 195, max: 235, display: "195-235 lbs" },
      chest: { min: 46, max: 52, display: "46-52\"" },
      build: 'Stocky'
    },
    'A3': {
      height: { min: 70, max: 74, display: "5'10\" - 6'2\"" },
      weight: { min: 200, max: 240, display: "200-240 lbs" },
      chest: { min: 44, max: 50, display: "44-50\"" },
      build: 'Standard'
    },
    'A4': {
      height: { min: 73, max: 77, display: "6'1\" - 6'5\"" },
      weight: { min: 230, max: 280, display: "230-280 lbs" },
      chest: { min: 48, max: 54, display: "48-54\"" },
      build: 'Standard'
    }
  };

  // ============================================
  // NO-GI SIZES (S, M, L, XL, 2XL)
  // Rashguards and Shorts
  // ============================================
  const nogiSizes = {
    'S': {
      height: { min: 64, max: 67, display: "5'4\" - 5'7\"" },
      weight: { min: 130, max: 155, display: "130-155 lbs" },
      chest: { min: 34, max: 40, display: "34-40\"" },
      waist: { min: 28, max: 32, display: "28-32" }
    },
    'M': {
      height: { min: 67, max: 70, display: "5'7\" - 5'10\"" },
      weight: { min: 155, max: 180, display: "155-180 lbs" },
      chest: { min: 38, max: 44, display: "38-44\"" },
      waist: { min: 30, max: 34, display: "30-34" }
    },
    'L': {
      height: { min: 69, max: 72, display: "5'9\" - 6'0\"" },
      weight: { min: 175, max: 200, display: "175-200 lbs" },
      chest: { min: 40, max: 46, display: "40-46\"" },
      waist: { min: 32, max: 36, display: "32-36" }
    },
    'XL': {
      height: { min: 71, max: 75, display: "5'11\" - 6'3\"" },
      weight: { min: 195, max: 230, display: "195-230 lbs" },
      chest: { min: 42, max: 48, display: "42-48\"" },
      waist: { min: 34, max: 40, display: "34-40" }
    },
    '2XL': {
      height: { min: 73, max: 77, display: "6'1\" - 6'5\"" },
      weight: { min: 220, max: 260, display: "220-260 lbs" },
      chest: { min: 46, max: 52, display: "46-52\"" },
      waist: { min: 38, max: 44, display: "38-44" }
    }
  };

  // ============================================
  // HELPER FUNCTIONS
  // ============================================

  /**
   * Normalize size string to match our keys
   * Handles variations like "a2", "A2", "Size A2", etc.
   */
  function normalizeSize(sizeStr) {
    if (!sizeStr) return null;
    
    // Clean the string
    let normalized = sizeStr.toString().trim().toUpperCase();
    
    // Remove common prefixes
    normalized = normalized.replace(/^SIZE\s*/i, '');
    normalized = normalized.replace(/^-\s*/, '');
    
    // Handle Gi sizes
    const giMatch = normalized.match(/A([0-4])(L|H)?/i);
    if (giMatch) {
      return 'A' + giMatch[1] + (giMatch[2] ? giMatch[2].toUpperCase() : '');
    }
    
    // Handle No-Gi sizes
    const nogiMatch = normalized.match(/^(2?X?L|S|M)$/i);
    if (nogiMatch) {
      return nogiMatch[1].toUpperCase();
    }
    
    // Handle "SMALL", "MEDIUM", "LARGE", "EXTRA LARGE"
    const wordMap = {
      'SMALL': 'S',
      'MEDIUM': 'M',
      'LARGE': 'L',
      'EXTRA LARGE': 'XL',
      'EXTRALARGE': 'XL',
      'X-LARGE': 'XL',
      'XLARGE': 'XL',
      'XX-LARGE': '2XL',
      'XXLARGE': '2XL',
      '2X-LARGE': '2XL'
    };
    
    if (wordMap[normalized]) {
      return wordMap[normalized];
    }
    
    return null;
  }

  /**
   * Get size data for a given size string
   * Returns null if size not found
   */
  function getSizeData(sizeStr) {
    const normalized = normalizeSize(sizeStr);
    if (!normalized) return null;
    
    // Check Gi sizes first
    if (giSizes[normalized]) {
      return { ...giSizes[normalized], type: 'gi', size: normalized };
    }
    
    // Check No-Gi sizes
    if (nogiSizes[normalized]) {
      return { ...nogiSizes[normalized], type: 'nogi', size: normalized };
    }
    
    return null;
  }

  /**
   * Detect if a size is a Gi size
   */
  function isGiSize(sizeStr) {
    const data = getSizeData(sizeStr);
    return data && data.type === 'gi';
  }

  /**
   * Detect if a size is a No-Gi size
   */
  function isNogiSize(sizeStr) {
    const data = getSizeData(sizeStr);
    return data && data.type === 'nogi';
  }

  /**
   * Convert inches to feet and inches display
   */
  function inchesToFeetInches(inches) {
    const ft = Math.floor(inches / 12);
    const inch = Math.round(inches % 12);
    return `${ft}'${inch}"`;
  }

  /**
   * Calculate estimated fit profile for multiple sizes
   * Returns combined height/weight range
   */
  function calculateFitProfile(sizes) {
    if (!sizes || sizes.length === 0) return null;
    
    const sizeDataList = sizes
      .map(s => getSizeData(s))
      .filter(d => d !== null);
    
    if (sizeDataList.length === 0) return null;
    
    // If only one unique size, return its data directly
    const uniqueSizes = [...new Set(sizeDataList.map(d => d.size))];
    if (uniqueSizes.length === 1) {
      const data = sizeDataList[0];
      return {
        isSingleSize: true,
        height: data.height,
        weight: data.weight,
        sizes: uniqueSizes,
        type: data.type
      };
    }
    
    // Multiple different sizes - calculate combined range
    let minHeight = Infinity, maxHeight = -Infinity;
    let minWeight = Infinity, maxWeight = -Infinity;
    
    sizeDataList.forEach(data => {
      minHeight = Math.min(minHeight, data.height.min);
      maxHeight = Math.max(maxHeight, data.height.max);
      minWeight = Math.min(minWeight, data.weight.min);
      maxWeight = Math.max(maxWeight, data.weight.max);
    });
    
    return {
      isSingleSize: false,
      height: {
        min: minHeight,
        max: maxHeight,
        display: `${inchesToFeetInches(minHeight)} - ${inchesToFeetInches(maxHeight)}`
      },
      weight: {
        min: minWeight,
        max: maxWeight,
        display: `${minWeight}-${maxWeight} lbs`
      },
      sizes: uniqueSizes,
      type: sizeDataList[0].type // Use first item's type
    };
  }

  /**
   * Get all Gi sizes as an array (for dropdowns, tables, etc.)
   */
  function getAllGiSizes() {
    return Object.keys(giSizes).map(key => ({
      size: key,
      ...giSizes[key]
    }));
  }

  /**
   * Get all No-Gi sizes as an array
   */
  function getAllNogiSizes() {
    return Object.keys(nogiSizes).map(key => ({
      size: key,
      ...nogiSizes[key]
    }));
  }

  // ============================================
  // PUBLIC API
  // ============================================
  return {
    // Raw data access
    gi: giSizes,
    nogi: nogiSizes,
    
    // Helper functions
    normalizeSize: normalizeSize,
    getSizeData: getSizeData,
    isGiSize: isGiSize,
    isNogiSize: isNogiSize,
    inchesToFeetInches: inchesToFeetInches,
    calculateFitProfile: calculateFitProfile,
    getAllGiSizes: getAllGiSizes,
    getAllNogiSizes: getAllNogiSizes
  };
})();




